import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
import App from "./App";
import { A11yProvider } from "./components/a11y/A11yProvider";
import { queryClient } from "./lib/queryClient";
import "./i18n"; // initialise i18next (EN/BM) before the app renders
import "./index.css";

const root = document.getElementById("root");
if (!root) throw new Error("#root element missing");

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <A11yProvider>
          <App />
        </A11yProvider>
        {/*
          * Toasts: `closeButton` + a longer 6s default give users who need more
          * time a way to read/dismiss at their own pace (WCAG 2.2.1). Sonner
          * already pauses the timer on hover and on window blur, and renders an
          * aria-live region so screen readers announce each toast.
          */}
        <Toaster position="top-center" richColors closeButton duration={6000} pauseWhenPageIsHidden />
      </QueryClientProvider>
    </BrowserRouter>
  </StrictMode>
);
